import { get } from 'lodash';
import APIClient from '../services/APIClient';
import { appendInlineParams, appendQueryParams, makeChainRequest } from './helper';

const toPlazaCharger = (data) => ({
  chargerName: get(data, 'c_identity.c_name'),
  chargerState: get(data, 'charger_state'),
  condition: get(data, 'i2p2_state.c_condition'),
  fwVersion: get(data, 'fw_version'),
  online: get(data, 'i2p2_state.c_online'),
  status: get(data, 'i2p2_state.c_status'),
  uuid: get(data, 'c_uuid'),
});

class ChargersInfo {
  /**
   *
   * @param queryParams { page: 0, size: 10 }
   * @param bodyParams {
      filter_by: {
        linked_to_plaza: false,
        excluded_conditions: [
          dictStatuses.inactive,
          dictStatuses.pending
        ],
        query
      }
    }
   */
  shortDescription = (queryParams = {}, bodyParams = {}, oldVersion = false) => {
    const url = oldVersion ? 'plazas/chargers/short-description' : 'chargers/short-description';

    return APIClient.post(appendQueryParams(url, queryParams), bodyParams);
  };

  list = (queryParams = {}, bodyParams = {}) =>
    APIClient.post(appendQueryParams('/chargers/info', queryParams), bodyParams).then((response) => ({ response, toPlazaCharger }));

  export = (queryParams = {}, bodyParams = {}) =>
    APIClient.post(appendQueryParams('/chargers/info/export', queryParams), bodyParams).then((response) => response);

  getForMap = (queryParams = {}, bodyParams = {}) => APIClient.post(appendQueryParams('/chargers/map', queryParams), bodyParams);

  getForMapByChunk = (chainProps) => makeChainRequest({ request: this.getForMap, ...chainProps });

  // Not implemented yet
  getEvents = (chargerId) => APIClient.get(appendInlineParams('/chargers/:chargerId/events', { chargerId }));

  // Not implemented yet
  getChargerSnapshot = (chargerId) => APIClient.get(appendInlineParams('/chargers/:chargerId/state', { chargerId }));

  getDetails = (chargerId) => APIClient.get(appendInlineParams('/chargers/:chargerId/details', { chargerId }));

  getSessions = (chargerId, queryParams, bodyParams) =>
    APIClient.post(appendQueryParams(appendInlineParams('/chargers/:chargerId/sessions', { chargerId }), queryParams), bodyParams);
}

export default new ChargersInfo();
